module.exports = __webpack_public_path__ + "img/mc.0202b5bf.svg";